// npm packages
import React from 'react';
import Link from 'next/link';
import { categoryMenu } from '@/constants/list';

// components
import Container from '../Container';
import Text from '../Text';
import ImageComponentV2 from '../Image/ImageComponentV2';

function NavigationCategorySecondary() {
  return (
    <section className="bg-white pb-[100px] pt-24">
      <Container>
        <ul className="flex flex-wrap justify-center gap-x-[10px] gap-y-[24px]">
          {categoryMenu?.map((item) => (
            <li
              key={item?.id}
              className="flex flex-grow flex-shrink basis-2/12 justify-center min-w-[90px] max-w-[150px] min-h-[101px] bg-pale-grey rounded-xl shadow-trending-categories-search"
            >
              <Link
                prefetch={false}
                aria-label="Go to category secondary menu item"
                href={item?.link || '/'}
                className="w-full h-full flex flex-col items-center gap-[4px] p-8"
              >
                <div className="w-[48px] h-[48px] flex justify-center items-center">
                  <div className="w-full h-[48px] relative overflow-hidden">
                    <ImageComponentV2
                      className="object-contain"
                      src={item?.image}
                      alt={item?.name}
                      width={48}
                      height={48}
                      loading="lazy"
                    />
                  </div>
                  {/* <Icon
                        type={item.icon}
                      // className="size-full"
                      /> */}
                </div>
                <Text
                  type="span"
                  className="text-12 text-coarse-wool text-center font-encode-sans font-semibold leading-14 tracking-[0.24px] line-clamp-2"
                >
                  {item.name}
                </Text>
              </Link>
            </li>
          ))}
        </ul>
      </Container>
    </section>
  );
}

export default NavigationCategorySecondary;
